import classNames from 'classnames'
import './index.less'
import { useContext, useEffect, useState } from 'react';
import { Notice } from '@/commons/interface/notice';
import { NoticeType, getNoticeTypeName } from '@/commons/enums/notice-type';
import dayjs from 'dayjs';
import WorkOrderDetailPanel from '../work-order/detail';
import { message } from 'antd';
import { getNotices, readNotice } from '@/api/notice';
import ObjectDetailPanel from '../object-detail';
import { SystemStatus } from '@/commons/context/system-store';
import { SystemContext } from '@/App';
import { graphicStore } from '@/commons/store/graphic-store';

export default function NoticePanel() {

    const [activeTab, setActiveTab] = useState<string>('unread'); // 选中的页签
    const [dataList, setDataList] = useState<Notice[]>([]); // 通知列表
    const [selectedOrderId, setSelectedOrderId] = useState<number>(); // 当前查看的工单id
    const [selectedObjectType, setSelectedObjectType] = useState<string>(); // 当前查看的对象类型
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        // 查询数据
        generateData(false);
    }, [])

    const generateData = (hasRead: boolean) => {
        getNotices(hasRead).then(res => {
            let list: Notice[] = res.data;
            setDataList(list);
        }).catch(err => {
            message.error("获得通知失败");
        })
    }

    // 点击了某条通知，打开对象的详情或工单的详情
    const onOpenDetail = (item: Notice) => {
        if (!item.hasRead) {
            readNotice(item.id).then(res => {
                let newList = dataList.filter(data => data.id != item.id);
                setDataList(newList);
            })
        }
        // if (item.type == NoticeType.WORK_ORDER) {
        //     // 查看工单详情
        //     setSelectedOrderId(item.workOrderId);
        // } else if (item.type == NoticeType.REMIND) {
        let entity = graphicStore.extraContext.getCurrentViewEditor()?.entityDict[item.entityUuid];
        if (!entity) {
            message.error("对象不存在");
            return;
        }
        systemContext.setCurrentSelectedEntity(entity);
        setSelectedObjectType(entity.type)
        // }
    }

    if (selectedObjectType) {
        return (
            <ObjectDetailPanel />
        )
    }

    if (selectedOrderId != null) {
        return (
            <WorkOrderDetailPanel id={selectedOrderId} />
        )
    }

    return (
        <div className="notice-panel-container">
            <div className="tabs">
                <div className={classNames({
                    "tab-item": true,
                    "active": activeTab == "read"
                })} onClick={() => { setActiveTab('read'); generateData(true) }}>已读</div>
                <div className={classNames({
                    "tab-item": true,
                    "active": activeTab == "unread"
                })} onClick={() => { setActiveTab('unread'); generateData(false) }}>未读</div>
                {/* <div className={classNames({
                    "tab-item": true,
                    "active": activeTab == "recently"
                })}>最近一周</div> */}
            </div>
            <div className="list">
                {dataList.map(item => (
                    <div className="item" onClick={() => onOpenDetail(item)}>
                        <div className="icon"></div>
                        <div className="type">{`[${getNoticeTypeName(item.type)}] ${dayjs(item.gmtCreate).format('YYYY-MM-DD')}`}</div>
                        <div className="content">{item.content}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}